// removed by extract-text-webpack-plugin
module.exports = {"button":"common-Button-button","inputSize":"common-Button-inputSize","large":"common-Button-large","wide":"common-Button-wide","action":"common-Button-action","disabled":"common-Button-disabled","tall":"common-Button-tall","huge":"common-Button-huge","strench":"common-Button-strench","small":"common-Button-small"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Button/index.css
// module id = 1749
// module chunks = 0